/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
import { default as _get } from "lodash/get";
export class DataPipeline {
    constructor(items) {
        this.items = items;
        return this;
    }
    pipe(fn) {
        this.items = fn(this.items);
        return this;
    }
    each(fn) {
        for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i];
            fn(item);
        }
        return this;
    }
    filter(fn) {
        this.items = this.items.filter(fn);
        return this;
    }
    search(query, options) {
        options = Object.assign({}, { fieldPaths: null, fieldPath: null, case: false, skipBelowLength: 3 }, options || {});
        if (!options.case) {
            query = query.toLowerCase();
        }
        if ((!query && options.skipBelowLength >= 1) || (query.length < options.skipBelowLength)) {
            return this;
        }
        var fieldPaths = options.fieldPaths || [options.fieldPath];
        // Multifield matching is treated as an OR query
        this.items = this.items.filter(item => {
            let matched = false;
            for (let i = 0; i < fieldPaths.length; i++) {
                let fieldPath = fieldPaths[i];
                let value = _get(item, fieldPath);
                if (!options.case) {
                    value = value.toLowerCase();
                }
                if (value.indexOf(query) >= 0) {
                    matched = true;
                    break;
                }
            }
            return matched;
        });
        return this;
    }
    fork(condition, fn) {
        if (condition) {
            var pipeFork = new DataPipeline(this.items);
            this.items = fn(pipeFork).out();
        }
        return this;
    }
    out() {
        return this.items;
    }
}
export function pipeData(items) {
    return new DataPipeline(items);
}
//# sourceMappingURL=data-pipe.js.map